<template>
  <div class="main-box">
    <div class="content-cls">
      <img src="../../assets/activity_bg.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  created () {
    document.title = '默往会员优惠大放送'
  }
}
</script>

<style scoped lang="scss">
.content-cls{
  font-size: 0;
  img {
    width: 100%;
  }
}
</style>
